import React from 'react';
import { useCountdown } from './useCountdown';
import { motion } from 'framer-motion';
export function PricingCountdown() {
  const {
    minutes,
    seconds
  } = useCountdown();
  return <div className="py-10 px-6 bg-cream-dark" data-id="element-204">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-50px'
    }} transition={{
      duration: 0.5
    }} className="max-w-xl mx-auto text-center" data-id="element-205">
        <p className="text-xl md:text-2xl font-bold text-gray-900 mb-6" data-id="element-206">
          Hasta 3 cuotas fijas sin interés
        </p>

        <div className="flex items-center justify-center gap-4 mb-6" data-id="element-207">
          <div className="bg-gray-900 text-white rounded-2xl px-6 py-4 min-w-[90px]" data-id="element-208">
            <div className="text-4xl md:text-5xl font-bold tabular-nums" data-id="element-209">
              {minutes.toString().padStart(2, '0')}
            </div>
            <div className="text-xs uppercase tracking-widest text-gray-400 mt-1" data-id="element-210">
              Min
            </div>
          </div>
          <span className="text-3xl font-bold text-gray-400" data-id="element-211">:</span>
          <div className="bg-gray-900 text-white rounded-2xl px-6 py-4 min-w-[90px]" data-id="element-212">
            <div className="text-4xl md:text-5xl font-bold tabular-nums" data-id="element-213">
              {seconds.toString().padStart(2, '0')}
            </div>
            <div className="text-xs uppercase tracking-widest text-gray-400 mt-1" data-id="element-214">
              Seg
            </div>
          </div>
        </div>

        <p className="text-base text-red-600 font-medium flex items-center justify-center gap-2" data-id="element-215">
          <span className="inline-block w-2.5 h-2.5 bg-red-500 rounded-full animate-pulse" data-id="element-216" />
          Oferta por tiempo limitado — vence cuando termina el contador
        </p>
      </motion.div>
    </div>;
}